// extracted by mini-css-extract-plugin
export default {"overlay":"eA-z","bodyOpen":"fA-z","content":"gA-z","header":"hA-z","close":"iA-z","closeNoHeading":"jA-z"};